import { default as Only } from './Only';

export default Only;
